import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export default function About() {
  const { t } = useLang();
  const A = t.about;
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative border-b border-white/10 py-28 lg:py-36"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 grid grid-cols-12 gap-6 lg:gap-10">
        <div className="col-span-12 lg:col-span-3">
          <div className="sticky top-28">
            <div className="label-mono mb-4">{A.label}</div>
            <div className="font-mono text-[10px] tracking-widest text-white/40 uppercase">
              {A.side_a}
              <br />
              <span className="text-white/70">{A.side_b}</span>
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="col-span-12 lg:col-span-9"
        >
          <h2 className="display-2 text-3xl md:text-5xl lg:text-6xl text-white">
            {A.title_a}
            <br />
            {A.title_b}{" "}
            <span className="text-white/40">{A.title_muted}</span>{" "}
            <span className="text-[#FF3333]">{A.title_accent}</span>
          </h2>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl">
            <p className="text-white/70 text-base leading-relaxed">{A.body_a}</p>
            <p className="text-white/70 text-base leading-relaxed">{A.body_b}</p>
          </div>

          {/* Director — brief intro line, below body */}
          <div className="mt-12 pt-8 border-t border-white/10 flex flex-wrap items-baseline gap-x-4 gap-y-2 text-white/75">
            <span className="label-mono text-[#FF3333]">// Director</span>
            <a
              href="https://namu.wiki/w/%EC%9D%B4%EC%A2%85%ED%95%98(%EA%B5%90%EC%88%98)"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="director-profile-link"
              className="font-display font-bold text-base text-white hover:text-[#FF3333] transition-colors underline decoration-white/20 underline-offset-4 hover:decoration-[#FF3333]"
            >
              Jong-Ha Lee · 이종하 교수 ↗
            </a>
            <span className="text-white/55 text-sm">
              Professor, Keimyung University · Founding Director of CATT
            </span>
          </div>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 border border-white/10 divide-x divide-white/10">
            {A.kpis.map((b, i) => (
              <div key={i} className="p-6">
                <div className="font-display font-bold text-xl text-white">{b.k}</div>
                <div className="mt-3 font-mono text-[10px] tracking-widest uppercase text-white/40 leading-relaxed">
                  {b.v}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
